import { render, staticRenderFns } from "./plan-list.html?vue&type=template&id=22e2646a&scoped=true&external"
import script from "./plan-list.js?vue&type=script&lang=js&external"
export * from "./plan-list.js?vue&type=script&lang=js&external"
import style0 from "./plan-list.scss?vue&type=style&index=0&id=22e2646a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2646a",
  null
  
)

export default component.exports